import script from "./AppointmentDataFileTableRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppointmentDataFileTableRow.vue?vue&type=script&lang=ts&setup=true"

import "./AppointmentDataFileTableRow.vue?vue&type=style&index=0&id=00626661&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00626661"]])

export default __exports__